export default {"src":"/_next/static/media/mysofie.3fe50a4f.svg","height":50,"width":80,"blurWidth":0,"blurHeight":0};